// ED3N AI floating assistant
import { useState } from "react";
import { Sparkles, X, Send, Bot } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

export default function EdenChat() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { who: "eden", text: "I am ED3N. I navigate NEXUS with you. Ask me anything — creators, your wallet, your strategy." },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [sid, setSid] = useState(null);

  const send = async () => {
    const text = input.trim();
    if (!text) return;
    setMessages((m) => [...m, { who: "me", text }]);
    setInput(""); setLoading(true);
    const ctx = user?.role === "owner" ? "owner" : user?.role === "creator" ? "creator" : "viewer";
    try {
      const { data } = await api.post("/eden/ask", { prompt: text, context: ctx, session_id: sid });
      setSid(data.session_id);
      setMessages((m) => [...m, { who: "eden", text: data.reply }]);
    } catch (e) {
      setMessages((m) => [...m, { who: "eden", text: "ED3N is currently in echo mode. Try again shortly." }]);
    }
    setLoading(false);
  };

  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        data-testid="eden-fab"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-nexus-obsidian border border-nexus-cyan/40 flex items-center justify-center hover:border-nexus-cyan animate-pulse-glow"
      >
        {open ? <X className="w-5 h-5 text-white" /> : <Sparkles className="w-5 h-5 text-nexus-cyan" />}
      </button>
      {open && (
        <div data-testid="eden-panel" className="fixed bottom-24 right-6 z-50 w-[380px] max-w-[92vw] h-[520px] glass-strong flex flex-col">
          <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
            <div className="flex items-center gap-2">
              <Bot className="w-4 h-4 text-nexus-cyan" />
              <span className="font-display text-xs tracking-[0.3em]">ED3N</span>
            </div>
            <span className="text-[9px] tracking-[0.3em] text-white/40 uppercase">{user?.role || "viewer"} mode</span>
          </div>
          <div className="flex-1 overflow-y-auto px-4 py-4 space-y-3">
            {messages.map((m, i) => (
              <div key={i} className={`flex ${m.who === "me" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[80%] text-sm leading-relaxed p-3 ${m.who === "me" ? "bg-nexus-cyan/20 border border-nexus-cyan/40" : "bg-white/5 border border-white/10"}`}>
                  {m.text}
                </div>
              </div>
            ))}
            {loading && <div className="text-[11px] tracking-[0.3em] text-nexus-cyan uppercase">ED3N is thinking…</div>}
          </div>
          <div className="border-t border-white/10 p-3 flex gap-2">
            <input
              data-testid="eden-input"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Ask ED3N…"
              className="flex-1 bg-transparent border border-white/10 px-3 py-2 text-sm focus:outline-none focus:border-nexus-cyan"
            />
            <button data-testid="eden-send" onClick={send} className="btn-nexus !py-2 !px-4"><Send className="w-3.5 h-3.5" /></button>
          </div>
        </div>
      )}
    </>
  );
}
